export default "https://cdn-static-staging.gokick.com/assets/de9826e8866da471b448810e2f95d57cb57ac3c9/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";